// BORA Skin — collection + search facets (filter, sort, pagination) refreshed
// in place via Shopify's Section Rendering API.
//
// Design notes:
// - One form (#FacetsForm) is the single source of truth. The URL is built
//   from FormData, so it always reflects exactly what is checked — no state
//   is kept in JS.
// - The server renders every swappable region with data-facets-part, even
//   when empty, so a refresh replaces regions one-to-one and can never leave
//   a stale grid or lose the pagination node.
// - Events are delegated from the section root, so swapped markup needs no
//   re-binding.
(function () {
  var root = document.querySelector('[data-facets-section]');
  if (!root) return;

  var sectionId = root.getAttribute('data-facets-section');
  var form = document.getElementById('FacetsForm');
  var drawer = document.getElementById('filter-drawer');
  var desktop = window.matchMedia('(min-width: 1024px)');
  var controller = null;
  var lastUrl = location.pathname + location.search;
  var priceTimer = null;
  var releaseTrap = null;
  var drawerOpener = null;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // ── URL from form state ────────────────────────────────────────────────
  function urlFromForm() {
    var params = new URLSearchParams();
    var min = qs('#Filter-price-min');
    var max = qs('#Filter-price-max');
    // A reversed range would return nothing; swap it instead of punishing a typo.
    if (min && max && min.value !== '' && max.value !== '' && parseFloat(min.value) > parseFloat(max.value)) {
      var tmp = min.value; min.value = max.value; max.value = tmp;
    }
    new FormData(form).forEach(function (value, key) {
      if (value === '') return;
      params.append(key, value);
    });
    var query = params.toString();
    return form.getAttribute('action') + (query ? '?' + query : '');
  }

  // ── Fetch + swap ───────────────────────────────────────────────────────
  function render(url, opts) {
    opts = opts || {};
    if (controller) controller.abort();
    controller = new AbortController();
    lastUrl = url;

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    var openState = {};
    qsa('[data-facet-key]', root).forEach(function (d) { openState[d.getAttribute('data-facet-key')] = d.open; });
    var searchState = qsa('[data-facets-search]', root).map(function (i) { return i.value; });
    var focusedId = document.activeElement && document.activeElement.id;
    var bodyScroll = form.scrollTop;

    fetch(fetchUrl, { credentials: 'same-origin', signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        qsa('[data-facets-part]', doc).forEach(function (fresh) {
          var name = fresh.getAttribute('data-facets-part');
          var current = qs('[data-facets-part="' + name + '"]', document);
          if (current) current.innerHTML = fresh.innerHTML;
        });
        // The sort control sits outside the swapped regions; keep it in step
        // (matters for Back/Forward, where the URL — not the shopper — changed it).
        var freshSort = qs('[data-facets-sort]', doc);
        var sort = qs('[data-facets-sort]');
        if (freshSort && sort) sort.value = freshSort.value;

        // Keep the shopper's place: accordion states, brand search text, focus, drawer scroll.
        qsa('[data-facet-key]', root).forEach(function (d) {
          var key = d.getAttribute('data-facet-key');
          if (key in openState) d.open = openState[key];
        });
        qsa('[data-facets-search]', root).forEach(function (input, i) {
          if (searchState[i]) { input.value = searchState[i]; filterList(input); }
        });
        if (focusedId) {
          var el = document.getElementById(focusedId);
          if (el && typeof el.focus === 'function') el.focus({ preventScroll: true });
        }
        form.scrollTop = bodyScroll;

        if (opts.push !== false) history.pushState({ facets: true }, '', url);
        if (opts.scroll) scrollToResults();
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        // Network or server failure: fall back to a normal page load.
        location.href = url;
      })
      .finally(function () {
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
      });
  }

  function scrollToResults() {
    var target = qs('.plp__toolbar', root) || root;
    var top = target.getBoundingClientRect().top + window.scrollY - 90;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function submitForm() {
    var url = urlFromForm();
    if (url === lastUrl) return;
    render(url, { scroll: desktop.matches });
  }

  // ── Events (delegated) ─────────────────────────────────────────────────
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-facets-search]')) return;
    if (t.matches('[data-facets-price]')) { clearTimeout(priceTimer); submitForm(); return; }
    if (t.form === form || t.getAttribute('form') === 'FacetsForm') submitForm();
  });

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-facets-search]')) { filterList(t); return; }
    if (t.matches('[data-facets-price]')) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(submitForm, 800);
    }
  });

  // Enter in a price field applies instead of doing a full-page submit.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(priceTimer);
    submitForm();
  });

  root.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-facets-link]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    render(link.getAttribute('href'), { scroll: link.hasAttribute('data-facets-scroll') || desktop.matches });
  });

  window.addEventListener('popstate', function () {
    render(location.pathname + location.search, { push: false });
  });

  // ── Brand search inside the filter list ────────────────────────────────
  function normalize(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, '');
  }
  function filterList(input) {
    var q = normalize(input.value);
    var group = input.closest('.plp__filter-body');
    if (!group) return;
    var shown = 0;
    qsa('[data-facets-item]', group).forEach(function (li) {
      var name = qs('.plp__filter-name', li);
      var match = !q || normalize(name ? name.textContent : li.textContent).indexOf(q) > -1;
      li.hidden = !match;
      if (match) shown++;
    });
    var none = qs('[data-facets-nomatch]', group);
    if (none) none.hidden = shown > 0;
  }

  // ── Mobile drawer ──────────────────────────────────────────────────────
  function syncDrawerMode() {
    if (!drawer) return;
    if (desktop.matches) {
      if (drawer.classList.contains('is-open')) closeDrawer(true);
      drawer.removeAttribute('aria-hidden');
      drawer.removeAttribute('role');
      drawer.removeAttribute('aria-modal');
      drawer.inert = false;
    } else if (!drawer.classList.contains('is-open')) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
    }
  }

  function openDrawer(opener) {
    if (!drawer || desktop.matches) return;
    drawerOpener = opener || document.activeElement;
    drawer.classList.add('is-open');
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    qsa('[data-open-filter-drawer]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
    if (window.BORA && window.BORA.trapFocus) releaseTrap = window.BORA.trapFocus(drawer);
    var close = qs('.filter-drawer__close', drawer);
    if (close) close.focus();
  }

  function closeDrawer(silent) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = !desktop.matches;
    qsa('[data-open-filter-drawer]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    if (!silent && drawerOpener && typeof drawerOpener.focus === 'function') drawerOpener.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-filter-drawer]');
    if (opener) { openDrawer(opener); return; }
    if (e.target.closest('[data-close-filter-drawer]')) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  if (desktop.addEventListener) desktop.addEventListener('change', syncDrawerMode);
  else if (desktop.addListener) desktop.addListener(syncDrawerMode);
  syncDrawerMode();
})();
